import React from 'react'
import closeicon from '../../../../_metronic/images/closeSymbol.svg'
import {Col, Row, Spinner} from 'react-bootstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import TextField from '../../../sharedComponent/TextField/TextField'
import {useLazyQuery, useMutation} from '@apollo/client'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {CREATEALERTSETUP, GETALERTSETUP, UPDATEALERTSETUP} from '../../../../utils/GraphQLAPI'

const MySwal = withReactContent(Swal)

const enrollSchema = Yup.object().shape({
  daysForPhone: Yup.number()
    .typeError('No. of days must be a number')
    .positive('No. of days must be a positive number')
    .integer('No. of days must be an integer')
    .nullable(),
})

const AlertSetup = ({editedData, setEditedData, getProductSetup, loading, featureFlags}: any) => {
  const formik = useFormik({
    initialValues: {
      id: null,
      daysForPhone: null,
    },
    validationSchema: enrollSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      console.log('=====values', values)
      if (values.id === null) createAlertSetup()
      else updateAlertSetup()
    },
  })

  const handleOnChange = (e: any, name: string) => {
    console.log('======e.target.value', e.target.value)
    const value = e.target.value === '' ? null : e.target.value
    formik.setFieldValue(name, value)
  }

  const [getAlertSetup, {loading: queryLoading}] = useLazyQuery(GETALERTSETUP, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) => {
      formik.setValues({
        ...formik.values,
        id: data?.getAlertSetting?.id ? data?.getAlertSetting?.id : null,
        daysForPhone: data?.getAlertSetting?.noOfDaysPhoneRepeated
          ? data?.getAlertSetting?.noOfDaysPhoneRepeated
          : null,
      })
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  const [createAlertSetup] = useMutation(CREATEALERTSETUP, {
    variables: {
      createAlertSettingInput: {
        noOfDaysPhoneRepeated: formik.values.daysForPhone,
      },
    },
    onCompleted: (data) => {
      MySwal.fire({
        icon: 'success',
        title: 'Alert Setup added Successfully',
      })
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  const [updateAlertSetup] = useMutation(UPDATEALERTSETUP, {
    variables: {
      updateAlertSettingInput: {
        id: formik.values.id,
        noOfDaysPhoneRepeated: formik.values.daysForPhone ? formik.values.daysForPhone : null,
      },
    },
    onCompleted: (data) => {
      MySwal.fire({
        icon: 'success',
        title: data.updateAlertSetting,
      })
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })
  const handleModalOpen = async () => {
    getAlertSetup()
  }

  const handleModalClose = () => {
    formik.resetForm() // Resets form fields
  }

  return (
    <>
      <button
        className='btn btn-primary fs-7'
        onClick={handleModalOpen}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
      >
        <span>
          <i className='bi bi-gear-fill fs-6'></i>
        </span>
        Alert Setup
      </button>

      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <div className='modal-dialog modal-dialog-scrollable modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Alert Setup</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => handleModalClose()}
              >
                <img src={closeicon} alt='close' />
              </div>
            </div>

            <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2'>
              {queryLoading ? (
                <div className='text-center'>
                  <Spinner animation='border' className='text-gray-600' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div className='modal-md'>
                  <div className='modal-content'>
                    <div className='modal-body pt-0'>
                      <form>
                        <Row className='d-flex align-items-end mt-5 no-gutters noPadding'>
                          <Col sm={12} md={12} className='pb-7'>
                            <TextField
                              fieldTitle={'Phone numbers used in Enrollment more than once in'}
                              fieldTitleAfter={'of days'}
                              fieldType={'number'}
                              filedTitleMandatory={false}
                              fieldName={'daysForPhone'}
                              placeHolder={'Enter no. of days'}
                              fieldValue={formik.getFieldMeta('daysForPhone').value}
                              handleOnChange={handleOnChange}
                              formik={formik}
                            />
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className='modal-footer'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  formik.submitForm()
                }}
                disabled={!formik.isValid || !formik.dirty} 
                data-bs-dismiss={formik.isValid && formik.dirty ? 'modal' : undefined}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AlertSetup
